export default "__VITE_ASSET__c_nZ4u0V__"